import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {FaHome, FaVideo, FaYoutube, FaFacebook, FaBars} from 'react-icons/fa';
import {GiChurch} from 'react-icons/gi';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobileMenuOpen: false
        };
    }

    toggleMobileMenu = () => {
        this.setState(prevState => ({
            isMobileMenuOpen: !prevState.isMobileMenuOpen
        }));
    }

    render() {
        const {isMobileMenuOpen} = this.state;
        const currentPath = window.location.pathname;
        
        return (
            <header className="bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100 sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        {/* Logo区域 */}
                        <div className="flex-shrink-0">
                            <Link to="/" className="flex items-center space-x-3 group">
                                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-md group-hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                                    <img 
                                        src="/logo_eecf_w192.png" 
                                        alt="EECF Logo" 
                                        className="w-8 h-8 object-contain"
                                    />
                                </div>
                                <div className="hidden sm:block">
                                    <h1 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">EECF</h1>
                                    <p className="text-xs text-gray-500 font-medium">基督教法国华人教会</p>
                                </div>
                            </Link>
                        </div>

                        {/* 导航菜单 */}
                        <nav className="hidden md:flex items-center space-x-1">
                            <Link 
                                to="/" 
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                                    currentPath === '/' 
                                        ? 'bg-blue-50 text-blue-700 border border-blue-200 shadow-sm' 
                                        : 'text-gray-700 hover:bg-blue-50 hover:text-blue-700'
                                }`}
                                onClick={() => this.setState({isMobileMenuOpen: false})}
                            >
                                <div className="flex items-center space-x-2">
                                    <FaHome className="text-sm" />
                                    <span>首页</span>
                                </div>
                            </Link>
                            <Link 
                                to="/live" 
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                                    currentPath === '/live' 
                                        ? 'bg-blue-50 text-blue-700 border border-blue-200 shadow-sm' 
                                        : 'text-gray-700 hover:bg-blue-50 hover:text-blue-700'
                                }`}
                                onClick={() => this.setState({isMobileMenuOpen: false})}
                            >
                                <div className="flex items-center space-x-2">
                                    <FaVideo className="text-sm" />
                                    <span>直播</span>
                                </div>
                            </Link>
                            <a 
                                href="https://youtube.com/@eecf" 
                                className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-red-50 hover:text-red-700 transition-all duration-200 flex items-center space-x-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaYoutube className="text-red-500 text-sm" />
                                <span>YouTube</span>
                            </a>
                            <a 
                                href="https://www.facebook.com/EECF26" 
                                className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 flex items-center space-x-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFacebook className="text-blue-600 text-sm" />
                                <span>Facebook</span>
                            </a>
                        </nav>

                        {/* 移动端菜单按钮 */}
                        <div className="md:hidden">
                            <button
                                onClick={this.toggleMobileMenu}
                                className="p-2 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                            >
                                <FaBars className="w-5 h-5" />
                            </button>
                        </div>
                    </div>

                    {/* 移动端菜单 */}
                    {isMobileMenuOpen && (
                        <div className="md:hidden py-4 border-t border-gray-100 bg-white/95 backdrop-blur-md">
                            <div className="flex flex-col space-y-2">
                                <Link 
                                    to="/" 
                                    className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                                        currentPath === '/' 
                                            ? 'bg-blue-50 text-blue-700 border border-blue-200 shadow-sm' 
                                            : 'text-gray-700 hover:bg-blue-50 hover:text-blue-700'
                                    }`}
                                    onClick={() => this.setState({isMobileMenuOpen: false})}
                                >
                                    <div className="flex items-center space-x-2">
                                        <FaHome className="text-sm" />
                                        <span>首页</span>
                                    </div>
                                </Link>
                                <Link 
                                    to="/live" 
                                    className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                                        currentPath === '/live' 
                                            ? 'bg-blue-50 text-blue-700 border border-blue-200 shadow-sm' 
                                            : 'text-gray-700 hover:bg-blue-50 hover:text-blue-700'
                                    }`}
                                    onClick={() => this.setState({isMobileMenuOpen: false})}
                                >
                                    <div className="flex items-center space-x-2">
                                        <FaVideo className="text-sm" />
                                        <span>直播</span>
                                    </div>
                                </Link>
                                <a 
                                    href="https://youtube.com/@eecf" 
                                    className="px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-red-50 hover:text-red-700 transition-all duration-200 flex items-center space-x-2"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => this.setState({isMobileMenuOpen: false})}
                                >
                                    <FaYoutube className="text-red-500 text-sm" />
                                    <span>YouTube</span>
                                </a>
                                <a 
                                    href="https://www.facebook.com/EECF26" 
                                    className="px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 flex items-center space-x-2"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => this.setState({isMobileMenuOpen: false})}
                                >
                                    <FaFacebook className="text-blue-600 text-sm" />
                                    <span>Facebook</span>
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </header>
        );
    }
}

export default Header;